import styled from "styled-components";

export const QuestionsWrapper = styled.div`
.answer-box{
${'' /* border-radius: 4px; */}
border-top: 1px solid #EFEFEF;
background: rgba(254, 254, 254, 0.60);
padding:18px 0px;
${'' /* margin:12px 0px; */}
color: #184A61;
font-family: Lato;
font-size: 16px;
font-style: normal;
font-weight: 400;
line-height: 20px;
display:flex;
justify-content:space-between;
align-items:center;
}

.desc{
    color:  #BDBDBD;
font-size: 14px;
}
`